import {Box, BoxProps, Divider} from "@mui/material";
import {Container} from "../components/Container";
import {Link} from "../components/Link";
import {Text} from "../components/Text";
import {colors, layout, spacing} from "../theme";

type FooterLink = {
  label: string;
  href: string;
};

type FooterProps = {
  links?: FooterLink[];
  phoneNumber?: string;
  sx?: BoxProps["sx"];
};

const defaultLinks: FooterLink[] = [
  {label: "Terms and Conditions", href: "https://www.bounceai.com/terms-and-conditions"},
  {label: "State Notices", href: "https://www.bounceai.com/state-notices"},
  {label: "Privacy Policy", href: "https://www.bounceai.com/privacy-policy"},
  {label: "SMS Terms & Conditions", href: "https://www.bounceai.com/sms-terms-conditions"},
];

export const Footer = ({links = defaultLinks, phoneNumber = "(888) 482-5060", sx}: FooterProps) => (
  <Container
    center
    gap={0}
    sx={{
      position: "relative",
      width: "100vw",
      left: "50%",
      transform: "translateX(-50%)",
      backgroundColor: colors.primary[1000],
      padding: `${spacing[5]} 0 40px`,
      ...sx,
    }}
  >
    <Container fullWidth gap={2.5} sx={{maxWidth: layout.maxWidth, px: spacing[4]}}>
      <Text variant="body" color={colors.tertiary[100]}>
        <Box component="span" sx={{fontWeight: 600}}>
          Bounce AI, Inc. is a debt collector{" "}
        </Box>
        attempting to collect a debt. Any information obtained will be used for that purpose.
      </Text>

      <Text variant="body" color={colors.tertiary[100]}>
        © {new Date().getFullYear()} Bounce AI All rights reserved.
        <br />
        333 Metro Park, S-205, Rochester, New York 14623
        <br />
        Call us at:{" "}
        <Link href={`tel:${phoneNumber}`} sx={{color: colors.tertiary[100]}}>
          {phoneNumber}
        </Link>
      </Text>

      <Divider sx={{borderColor: "rgba(253, 251, 248, 0.2)"}} />

      <Container gap={0}>
        {links.map((link) => (
          <Link
            key={link.label}
            href={link.href}
            target="_blank"
            rel="noopener"
            color={colors.tertiary[100]}
            sx={{textDecorationColor: colors.tertiary[100]}}
          >
            {link.label}
          </Link>
        ))}
      </Container>
    </Container>
  </Container>
);
